module.exports = __webpack_public_path__ + "static/media/alter-do-chao-pa.87e0aac3.jpg";